<script setup lang="ts">
defineProps<{
  icon?: 'error' | 'warning' | 'success' | 'fail'
  title?: string
  subTitle?: string
}>()

defineEmits(['onClick'])
</script>

<template>
  <div class="order-create flex flex-col items-center">
    <img v-if="icon === 'success'" class="w-60px h-60px mb-20px" src="../../assets/icons/success.svg">
    <img v-if="icon === 'warning'" class="w-60px h-60px mb-20px" src="../../assets/icons/warning.svg">
    <img v-if="icon === 'fail'" class="w-60px h-60px mb-20px" src="../../assets/icons/fail.svg">
    <img v-if="icon === 'error'" class="w-60px h-60px mb-20px" src="../../assets/icons/error.svg">

    <p class="title text-18px text-primary-100 leading-6 mb-19px"> {{ title }} </p>
    <p class="sub-title text-md text-primary"> {{ subTitle }}</p>

    <slot />

    <AButton class="comfirm-btn w-300px mt-20px" data-test-id="g0t3" @click="$emit('onClick')">
      {{ $t('UENBgObobQIqSj65k6uBN') }}
    </AButton>
  </div>
</template>
